<p-toast position="top-right" />

@defer (when hasSessionNotice()) {
    <app-session-notice />
}

<router-outlet></router-outlet>
